<template>
<div class="footer">
   <div class="home_foot">
	<div class="container flex_sb">
		<div class="home_foot_box home_foot_info">
			<div class="phone">0576-84287744</div>
			<div class="time">周一至周六8:00-17:00</div>
			<div class="ewm"><img src="../../assets/images/mjzz.jpg" /> <img src="../../assets/images/ewm.jpg" /></div>
			<div class="des">扫码关注模具执行官(左)模来模往小程序(右)<br />实时查看云工厂动态</div>
		</div>
		<div class="home_foot_box">
			<h3>资源中心</h3>
			<ul>
				<li><a href="">快速询价</a></li>
				<li><a href="">模具报价</a></li>
				<li><a href="">机加工报价</a></li>
			</ul>
		</div>
		<div class="home_foot_box">
			<h3>公司信息</h3>
			<ul>
				<li><a href="">云工厂简介</a></li>
				<li><a href="">服务优势</a></li>
				<li><a href="">联系我们</a></li>
				<li><a href="">关于我们</a></li>
			</ul>
		</div>
		<div class="home_foot_box">
			<h3>网站条款</h3>
			<ul>
				<li><a href="">服务协议</a></li>
				<li><a href="">法律声明</a></li>
				<li><a href="">隐私条款</a></li>
			</ul>
		</div>
	</div>
</div>
<div class="copy">版权所有 © 台州市天网网络有限公司<a class="copy" href="https://beian.miit.gov.cn"> 浙B2-20080268-5</a></div>
</div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_foot{padding: 50px 0; background: #373d42;}
.home_foot_box{width: 19%;}
.home_foot_info{width: 38%; text-align: center; color: #fff; font-weight: bold;}
.home_foot_info .phone{font-size: 30px;margin-bottom: 8px;}
.home_foot_info .ewm img{width: 160px; margin: 10px 0 10px;}
.home_foot_info .des{line-height: 26px; color: #a4a9ac;}
.home_foot_box h3{font-size: 22px; margin-bottom: 15px; color: #fff; font-weight: normal;}
.home_foot_box li{line-height: 30px;}
.home_foot_box li a{color: #a4a9ac;}
.home_foot_box li a:hover{text-decoration: underline;}
.copy{background: #222; color: #999; text-align: center; height: 40px; line-height: 40px;}
</style>
